import { voyageList } from 'VesselMaster/vesselMaster.hooks';
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query';
import { Card, CardHeader, CardBody, Col, Row, Label, Button, Modal } from 'reactstrap'
import { queryKeyes } from 'shared/queryKeys';
import ErrorComponent from 'Components/ErrorComponent';
import Loading from 'Components/Loading';
import LNGCargoQuality from 'Components/LNGCargoQuality';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import { setVesselID } from 'Store/Generic/ReportingSlice';

const PendingLNGCargoDetails = (vesselId: any) => {
    /** State variables */
    const [modalState, setModalState] = useState(false);
    const dispatch = useDispatch();
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    /** State variables end */

    /** useEffect start */
    useEffect(() => {
        dispatch(setVesselID(vesselId?.VesselID));
    }, [vesselId, dispatch])
    /** useEffect end */

    /** Queries */
    /** Vessel specific voyages */
    const { data: Voyages, isLoading: VoyagesLoading, isError: VoyagesError } = useQuery(
        [queryKeyes.vessel.VoyageList.key, vesselId?.VesselID],
        async () => {
            return await voyageList(vesselId?.VesselID > 0 ? vesselId.VesselID : VesselID);
        },
        { staleTime: Infinity }
    )
    /** Queries end */

    const handleAddDetailsButtonClick = () => {
        setModalState(!modalState);
    }

    /** Open close modal */
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_backdrop() {
        setModalState(!modalState);
        removeBodyCss();
    }

    return (
        <>
            {VoyagesLoading && <Loading message='Loading required data!' />}
            {VoyagesError && <ErrorComponent message='Unable to load required data!' />}
            {!VoyagesLoading && !VoyagesError &&
                <Card>
                    <CardHeader>
                        <h5>Pending LNG Cargo Quality Details</h5>
                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive ">
                            <table className="table mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Voyage</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Voyages?.map((voyage: any, index: number) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <Label>{voyage.voyage_number}</Label>
                                                    </td>
                                                    <td>
                                                        <Button type="button"
                                                            color="primary" onClick={() => handleAddDetailsButtonClick()}>
                                                            Add Details
                                                        </Button>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            }
            {modalState === true &&
                <Modal
                    size='xl'
                    isOpen={modalState}
                    toggle={() => {
                        tog_backdrop();
                    }}
                    backdrop={"static"}
                    id="staticBackdrop"
                >
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">
                            LNG Cargo Quality Details
                        </h5>
                        <button
                            onClick={() => {
                                setModalState(false);
                            }}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col lg={6}>
                                <LNGCargoQuality
                                    VesselID={vesselId.VesselID}
                                    cargoOperation={'loading'}
                                    cardHeader={'LNG Cargo Loading Quality Details'}
                                />
                            </Col>
                            <Col lg={6}>
                                <LNGCargoQuality
                                    VesselID={vesselId.VesselID}
                                    cargoOperation={'discharging'}
                                    cardHeader={'LNG Cargo Discharging Quality Details'}
                                />
                            </Col>
                        </Row>
                    </div>
                </Modal>
            }
        </>
    )
}

export default PendingLNGCargoDetails